import { Dispatch } from "react"
import { InitSubscriptionData } from "../types"
import { SubscriptionProcessAction, SubscriptionProcessSyncActions } from "./types"

const createSyncActions = (dispatch: Dispatch<SubscriptionProcessAction>): SubscriptionProcessSyncActions => ({
  initSubscriptionData: (data: InitSubscriptionData) => {
    dispatch({ type: 'INIT_SUBSCRIPTION_DATA', payload: data })
  },
  setCurrentBorrowerProjectId: (borrowerProjectId: string | null) => {
    dispatch({ type: 'SET_CURRENT_BORROWER_PROJECT_ID', payload: borrowerProjectId })
  },
  setCurrentQuoteId: (quoteId: string | null) => {
    dispatch({ type: 'SET_CURRENT_QUOTE_ID', payload: quoteId })
  },
  setUnreadHistoryCount: (count: number) => {
    dispatch({ type: 'SET_UNREAD_HISTORY_COUNT', payload: count })
  },
  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading })
  },
  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  },
  reset: () => {
    dispatch({ type: 'RESET' })
  }
})

export default createSyncActions
